module.exports = __webpack_public_path__ + "static/RivieraNights-Regular-01062356c93a7c2566fc9ca3c585caf6.woff";